import { Templates, Components, utils } from 'zero';

const { Detail } = Templates;
const { Toaster } = Components;

const detailList = [{
  text: '银行渠道',
  key: 'channelBankId',
}, {
  text: '贷款产品类型',
  key: 'loanProductType',
  format: {
    '00': '个人小额信贷',
    '01': '企业小微信贷',
    '03': '个人大额贷款',
  }
}, {
  text: '贷款产品名称',
  key: 'loanProductName',
}, {
  text: '贷款产品描述',
  key: 'loanProductDescription',
}, {
  text: '还款方式',
  key: 'repaymentMethod',
  format: {
    '01': '等额本息',
    '02': '等额本金',
    '03': '到期一次性还本付息',
    '04': '按月付息到期还本',
    '05': '一次付息到期还本',
  }
}, {
  text: '产品期限类型',
  key: 'loanProductTermType',
  format: {
    '01': '固定期限',
    '02': '浮动期限',
    '03': '循环期限',
  }
}, {
  text: '期限单位',
  key: 'termUnit',
  format: {
    1: '天',
    2: '月'
  }
}, {
  text: '固定产品期限',
  key: 'fixedLoanProductTerm',
  isShow: v => v === '01',
  isShowParams: ['loanProductTermType']
}, {
  text: '贷款利率类型',
  key: 'loanInterestRateType',
  format: {
    1: '固定',
    2: '浮动'
  }
}, {
  text: '固定贷款利率',
  key: 'fixedLoanInterestMonthRate',
  after: '%',
  isShow: v => v === '1',
  isShowParams: ['loanInterestRateType'],
}, {
  text: '浮动贷款利率',
  isShow: v => v === '2',
  isShowParams: ['loanInterestRateType'],
  items: [{
    key: 'minFloatLoanInterestMonthRate',
    after: '%- '
  }, {
    key: 'maxFloatLoanInterestMonthRate',
    after: '%'
  }]
}, {
  text: '起息条件类型',
  key: 'effectDayType',
  format: {
    1: '放款成功',
    2: '签约成功'
  }
}, {
  text: '起息日',
  key: 'effectDay',
}, {
  text: '起始放贷时间',
  key: 'openLoanTime',
  format: ['date', 'yyyy-MM-dd hh:mm:ss']
}, {
  text: '结束放贷时间',
  key: 'closeLoanTime',
  format: ['date', 'yyyy-MM-dd hh:mm:ss']
}, {
  text: '配额类型',
  key: 'quotaType',
  format: {
    '01': '不限额',
    '02': '固定限额',
    '03': '自动同步配额',
  }
}, {
  text: '产品总配额',
  key: 'totalQuota',
  isShow: v => v === '02',
  isShowParams: ['quotaType'],
}, {
  text: '产品日配额',
  key: 'dayQuota',
  isShow: v => v === '02',
  isShowParams: ['quotaType'],
}, {
  text: '贷款资金来源渠道',
  key: 'fundSourceType',
  format: {
    '01': '方付通',
    '02': '渠道银行',
    '03': '混合',
  }
}, {
  text: '最小贷款金额',
  key: 'minLoanAmount',
}, {
  text: '最大贷款金额',
  key: 'maxLoanAmount',
}, {
  text: '借款服务费类型',
  key: 'loanFeeType',
  format: {
    '00': '不收取',
    '01': '服务费前置放款扣除',
    '02': '服务费按月均分',
    '03': '服务费到期一次性收取',
  }
}, {
  text: '借款服务费率',
  key: 'loanFeeRate',
  isShow: v => v !== '00',
  isShowParams: ['loanFeeType']
}, {
  text: '逾期免息期限',
  key: 'lateChargeFreeDays',
}, {
  text: '逾期罚息类型',
  key: 'lateChargeRateType',
  format: {
    '00': '无罚息',
    '01': '固定罚息利率当期未还金额按天计算',
    '02': '递进罚息未还金额按天计算',
  }
}, {
  text: '逾期固定罚息费率',
  key: 'fixedLateChargeRate',
  after: ' %/天',
  isShow: v => v === '01',
  isShowParams: ['lateChargeRateType'],
}, {
  text: '逾期浮动罚息费率',
  isShow: v => v === '02',
  isShowParams: ['lateChargeRateType'],
  items: [{
    key: 'baseFloatLateChargeRate',
    after: ' %/天 -',
  }, {
    key: 'progressiveFloatLateChargeRate',
    after: ' %/天',
  }]
}, {
  text: '备注',
  key: 'remark',
}];

const titlepart = {
  title: '信贷产品详情',
  note: ''
};

utils.fetch('/api/bosscredit/product/id', {
  method: 'GET',
  data: {
    loanProductId: utils.getUrlParam().id
  },
  headers: {
    token: localStorage.getItem('token'),
    userId: localStorage.getItem('userId')
  }
}).then((res) => {
  Detail({
    detailList,
    respData: res.data,
    titlepart
  });
}, (error) => {
  Toaster.toaster({ type: 'error', content: (error && error.message) || '获取数据错误', time: 3000 });
});



// WEBPACK FOOTER //
// ./example/src/page/creditProductDetail/index.js